import { ShippingRestrictions } from '@adapters/bigcommerce/types/product';

export const determineStorePickupRestriction = ({
  storeUID,
  restrictionLevel,
  defaultRestriction = true,
}: {
  storeUID: string | null;
  restrictionLevel?: ShippingRestrictions['restriction_level'] | null;
  defaultRestriction?: boolean | null;
}) => {
  if (process.env.NEXT_PUBLIC_ENABLE_LOGGING === 'true') {
    console.log('determineStorePickupRestriction', {
      storeUID,
      restrictionLevel,
    });
  }
  if (!storeUID) {
    return defaultRestriction;
  }
  return storeUID.includes('hbc-') && ['R10'].includes(restrictionLevel || '');
};
